import { Box, Button, Typography } from '@mui/material';
import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: 2,
            textAlign: 'center',
            backgroundImage: 'url(/assets/tawhadi_background.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'repeat',
          }}
        >
          <Typography variant="h4" gutterBottom>
            حدث خطأ غير متوقع
          </Typography>
          <Typography variant="body1" gutterBottom>
            نعتذر، حدث خطأ في التطبيق
          </Typography>
          <Button
            variant="contained"
            onClick={() => window.location.href = '/home'}
            sx={{ marginTop: 2 }}
          >
            العودة للصفحة الرئيسية
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
